import { Observable } from 'rxjs';
import { InjectionToken } from '@angular/core';

export const INSURANCE_SERVICE: InjectionToken<IInsuranceService> = new InjectionToken<IInsuranceService>('IInsuranceService');

export interface IInsuranceService {
  reportInsuranceProblem(id: number, message: string): Observable<void>;
}